import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import IconButton from '@material-ui/core/IconButton'
import Link from '@material-ui/core/Link'
import { makeStyles, Theme } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import Skeleton from '@material-ui/lab/Skeleton'
import clsx from 'clsx'
import React from 'react'

export const ThumbnailImageStyles = makeStyles({
    thumbnailImage: {
        objectFit: 'cover',
    },
    thumbnailImageHeightWidth: {
        width: 190,
        height: 95,
    },
})

const galleryItemStyles = makeStyles((theme: Theme) => ({
    galleryItemContainer: {
        '&:hover': {
            backgroundColor: '#f3f3f3',
        },
    },
    imageContainer: ({ imageUrl }: { imageUrl: string }) => ({
        backgroundImage: `url("${imageUrl}")`,
        backgroundSize: 'cover',
    }),
    indexWidth: { width: theme.spacing(4) },
    hyperlinkText: { fontSize: pxToRem(13) },
    defaultTextContainer: { fontSize: 12, color: '#f78909' },
}))

export interface GalleryItemProps {
    imageUrl: string
    index: number
    isVideo: boolean
    mediaId: string
    onRemoveClick: (id: string) => void
    thumbnailFetching?: boolean
    title: string
}

export const GalleryItem = ({
    imageUrl,
    index,
    isVideo,
    mediaId,
    onRemoveClick,
    thumbnailFetching = false,
    title,
}: GalleryItemProps) => {
    const thumbnailImageClasses = ThumbnailImageStyles()
    const classes = galleryItemStyles({ imageUrl })

    const handleIconButtonClick = () => {
        onRemoveClick(mediaId)
    }

    return (
        <GridContainer
            spacing={2}
            alignItems="center"
            className={clsx(
                classes.galleryItemContainer,
                'galleryItemContainer'
            )}
        >
            <GridItem className={classes.indexWidth}>{index}</GridItem>
            <GridItem md={3}>
                {thumbnailFetching ? (
                    <Skeleton
                        variant="rect"
                        className={clsx(
                            thumbnailImageClasses.thumbnailImageHeightWidth,
                            'galleryItemLoading'
                        )}
                    />
                ) : (
                    <div
                        className={clsx(
                            thumbnailImageClasses.thumbnailImageHeightWidth,
                            classes.imageContainer,
                            'galleryItemImageContainer'
                        )}
                    />
                )}
            </GridItem>
            <GridItem md={6} className={classes.hyperlinkText}>
                <Link
                    href={isVideo ? title : imageUrl}
                    target="_blank"
                    rel="noopener"
                    className="gallerItemLink"
                >
                    <TooltipEllipsis text={title} />
                </Link>
            </GridItem>
            <GridItem md={1}>
                <IconButton
                    onClick={handleIconButtonClick}
                    className="galleryItemDeleteButton"
                >
                    <DeleteIcon color="primary" fontSize="small" />
                </IconButton>
            </GridItem>
            {index === 1 && (
                <GridItem
                    md={1}
                    className={clsx(
                        classes.defaultTextContainer,
                        'galleryItemDefaultContainer'
                    )}
                >
                    Default
                </GridItem>
            )}
        </GridContainer>
    )
}
